import {
  EMAIL_CHANGED,
  PASSWORD_CHANGED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  USER_IDENTIFIED,
  SIGNOUT,
  RESET_PASSWORD_SET,
  ERROR_PROP_SET,
  LOADING_TRUE,
  AUTH_TYPE,
  AUTH_COMPLETE
} from '../actions/types';

const INITIAL_STATE = {
  email: '',
  user_email: null,
  password: '',
  user_id: null,
  error: '',
  loading: false,
  token: '',
  reset_password_token: '',
  reset_password_email: '',
  auth_type: null,
  authenticated: false
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOADING_TRUE:
      return { ...state, loading: action.payload };
    case EMAIL_CHANGED:
      return { ...state, email: action.payload };
    case PASSWORD_CHANGED:
      return { ...state, password: action.payload };
    case LOGIN_SUCCESS:
      return { ...state,
        token: action.payload.token,
        authenticated: true,
        user_email: action.payload.email
      };
    case LOGIN_FAIL:
      return { ...state,
        token: null,
        error: action.payload.error,
        loading: false,
        authenticated: false,
        user_email: null
      }
    case USER_IDENTIFIED:
      return { ...state, user_id: action.payload };
    case ERROR_PROP_SET:
      return { ...state, error: action.payload }
    case RESET_PASSWORD_SET:
      return { ...state, reset_password_email: action.payload.email, reset_password_token: action.payload.token }
    case SIGNOUT:
      return { state };
    case AUTH_TYPE:
      return { ...state, auth_type: action.payload };
    case AUTH_COMPLETE:
      return { ...state, auth_type: null };
    default:
      return state;
  }
}
